import {
    Box,
    DialogTitle,
    Dialog,
    DialogActions,
    Button,
    DialogContent,
    List,
    ListItem,
    Alert,
    Typography,
} from '@mui/material';
import { ScopeT } from 'business/definitions';
import { capitalize } from 'helpers/helpers';
import { translateBlock } from 'i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getBlocks } from 'helpers/scopes';
import { useNoDashboardFilterScopeExpressionDescriptions } from './hooks/scopeTranslations';

const ScopeListItems = ({ scope }: { scope: ScopeT }) => {
    const blocks = getBlocks(scope);
    const scopeExpressionTranslations =
        useNoDashboardFilterScopeExpressionDescriptions(scope);
    return (
        <ListItem
            sx={{
                flexDirection: 'column',
                alignItems: 'flex-start',
            }}
        >
            <Typography variant="body1SemiBold">{scope.label}</Typography>
            <Box sx={{ p: 1 }}>
                <Typography variant="body1">
                    {scopeExpressionTranslations}
                </Typography>
                <List sx={{ listStyleType: 'disc', ml: 2 }}>
                    {blocks.map((block) => (
                        <ListItem
                            key={block}
                            sx={{ display: 'list-item', pt: 0, pb: 0 }}
                        >
                            {capitalize(translateBlock(block))}
                        </ListItem>
                    ))}
                </List>
            </Box>
        </ListItem>
    );
};
interface GridChartNoDashboardFilterModalProps {
    open: boolean;
    protectedScopes: ScopeT[];
    onClose: () => void;
    onSubmit: () => void;
}

const GridChartNoDashboardFilterModal = ({
    onSubmit,
    onClose,
    open,
    protectedScopes,
}: GridChartNoDashboardFilterModalProps): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <Dialog open={open} maxWidth="md">
            <DialogTitle>
                {t('chart.noDashboardFiltersModal.title')}
            </DialogTitle>
            <DialogContent>
                <Alert
                    severity="warning"
                    sx={{
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {t('chart.noDashboardFiltersModal.warning')}
                </Alert>
                <List>
                    {protectedScopes.map((scope) => (
                        <ScopeListItems key={scope.name} scope={scope} />
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.no')}</Button>
                <Button
                    onClick={() => {
                        onSubmit();
                        onClose();
                    }}
                    autoFocus
                >
                    {t('common.yes')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GridChartNoDashboardFilterModal;
